module.exports = __webpack_public_path__ + "28b67065/img/lock-icon.bb9c7166.svg";